import {get as _get, set as _set} from 'lodash';

/**
 * @ngdoc service
 * @name mainConfigurationService
 * @module portaro.main-configuration
 *
 * @description
 * This service provides storage for configuration with cooperation {@link directive:mainConfiguration}.
 */
export default class MainConfigurationService {
    static serviceName = 'mainConfigurationService';

    constructor() {
        this._configuration = {};
    }

    /**
     * @ngdoc method
     * @name mainConfigurationService#setParameter
     *
     * @param {string} key Key. Allowed characters are `a-z A-Z 0-9 . _`
     * @param {object} value Value
     *
     * @description
     * Method for setting configuration parameter. If key contains `.`, then it will be evaluated.
     * If key exists or contains non-allowed characters, service throws error.
     */
    setParameter(key, value) {
        if (_get(this, key)) {
            throw new Error(`MainConfigurationService: This property can be set only once: ${key}`);
        }

        if ((key.match(/(.*\.)?([a-zA-Z0-9_]*)$/)[0] || '').length !== key.length) {
            throw Error(`MainConfigurationService: Invalid key: ${key}`);
        }

        const keyPath = key.match(/(.*\.)?([a-zA-Z0-9_]*)$/);

        if (key.indexOf('.') > -1) {
            const modifiedPath = keyPath[1].substring(0, keyPath[1].length - 1);

            // eslint-disable-next-line no-undefined
            if (_get(this._configuration, modifiedPath, null) === null && this[modifiedPath] === undefined) {
                _set(this._configuration, modifiedPath, {});
            }

            Object.defineProperty(_get(this._configuration, modifiedPath), keyPath[2], {
                value,
                enumerable: true,
                writable: false,
                configurable: false
            });
        } else {
            Object.defineProperty(this._configuration, keyPath[0], {
                value,
                enumerable: true,
                writable: false,
                configurable: false
            });
        }
    }

    /**
     * @ngdoc method
     * @name mainConfigurationService#isPresent
     *
     * @param {string} key Key
     *
     * @returns {boolean}
     *
     * @description
     * Method find out whether a key is present.
     */
    isPresent(key) {
        return Boolean(_get(this._configuration, key));
    }

    /**
     * @ngdoc property
     * @name mainConfigurationService#configuration
     *
     * @description
     * Configuration object
     */
    get configuration() {
        return this._configuration;
    }
}